<template>
  <div class="serveuselist">
    <div class="serveuselist-top">
      <Form ref="selectForm" :model="serve" :label-width="110" class="tabTopForm">
        <FormItem label="服务提供者账号" class="name">
          <Input
            clearable
            v-model.trim="serve.proName"
            placeholder="请输入服务提供者账号"
            @on-change="searchServe"
            class="inputName"
          />
        </FormItem>
        <FormItem label="手机号" class="name">
          <Input
            clearable
            v-model.trim="serve.phone"
            placeholder="请输入手机号"
            @on-change="searchServe"
            class="inputName"
          />
        </FormItem>
        <FormItem label="企业名称" class="name">
          <Input
            clearable
            v-model.trim="serve.companyName"
            @on-change="searchServe"
            placeholder="请输入企业名称"
            class="inputName"
          />
        </FormItem>
        <FormItem label="审核状态">
          <Select
            class="select"
            v-model="serve.state"
            @on-change="searchServe"
            clearable
            placeholder="全部"
          >
            <Option v-for="item in stateList" :value="item.id" :key="item.id">
              {{
              item.name
              }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="提交时间">
          <Col span="12">
            <DatePicker
              v-model="serve.createTime"
              @on-change="searchServe"
              format="yyyy/MM/dd"
              type="daterange"
              placement="bottom-end"
              placeholder="请选择提交时间"
              style="width: 220px"
              :editable="false"
              transfer
            ></DatePicker>
          </Col>
        </FormItem>
        <!-- <FormItem label="">
          <Button
            class="searchBtn"
            type="primary"
            icon="ios-search"
            @click="searchServe"
            >搜索</Button
          >
        </FormItem>-->
      </Form>
    </div>
    <div class="serveuselist-content">
      <Row>
        <Table
          class="tableDom"
          ref="tableRef"
          stripe
          :columns="dataCol"
          :loading="tableLoading"
          :data="dataList"
        >
          <!-- 序号 -->
          <template slot-scope="{ index }" slot="xuhao">{{ index + 1 }}</template>
          <!-- 手机号 -->
          <template slot-scope="{ row }" slot="uPhone">
            <span v-if="row.uPhone">{{ row.uPhone }}</span>
            <span v-if="!row.uPhone">-</span>
          </template>
          <!-- 邮箱 -->
          <!-- <template slot-scope="{ row }" slot="email">
            <span v-if="row.email">
              {{ row.email }}
            </span>
            <span v-if="!row.email"> - </span>
          </template>-->
          <!-- 当前状态2待审核 3已驳回 -->
          <template slot-scope="{ row }" slot="state">
            <div v-if="row.certificationStatus == 2">
              <span class="dot1"></span>
              待审核
            </div>
            <div v-if="row.certificationStatus == 3">
              <span class="dot2"></span>
              已驳回
            </div>
          </template>
          <!-- 操作 -->
          <template slot-scope="{ row }" slot="action">
            <span>
              <span
                v-if="row.certificationStatus == 3"
                class="fontblue mr-16 fontcursor"
                v-permission="['detail']"
                @click="link('/servepro/serveproercheckinfo', row)"
              >查看详情</span>
            </span>
            <span>
              <span
                v-if="row.certificationStatus == 2"
                class="fontblue mr-16 fontcursor"
                v-permission="['audit']"
                @click="link('/servepro/serveproercheckinfo', row)"
              >审核</span>
            </span>
          </template>
        </Table>
      </Row>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="pageTotal"
          :page-size="pageSize"
          :page-size-opts="psize"
          :current="pageNum"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
  </div>
</template>

<script>
import { getServeProerChecklist } from "@/api/servicePro";
import TableMixin from "@/utils/mixins/tableMixin";

const dataCol = [
  {
    title: "序号",
    slot: "xuhao",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "服务提供者账号",
    key: "loginAccount",
    tooltip: true,
    minWidth: 160
  },
  {
    title: "手机号",
    slot: "uPhone",
    align: "center",
    tooltip: true,
    minWidth: 160
  },
  {
    title: "邮箱",
    key: "email",
    align: "center",
    tooltip: true,
    minWidth: 160,
    // render: (h, params) => {
    //   let texts = ""; //表格列显示文字
    //   if (params.row.email) {
    //     if (params.row.email.length > 6) {
    //       //进行截取列显示字数
    //       texts = params.row.email.substring(0, 16) + "...";
    //     } else {
    //       texts = params.row.email;
    //     }
    //   } else {
    //     return [texts || "-"];
    //   }
    //   return h(
    //     "Tooltip",
    //     {
    //       props: {
    //         placement: "top"
    //       }
    //     },
    //     [
    //       texts || "-",
    //       h(
    //         "span",
    //         {
    //           slot: "content",
    //           style: {
    //             whiteSpace: "normal",
    //             wordBreak: "break-all"
    //           }
    //         },
    //         params.row.email
    //       )
    //     ]
    //   );
    // }
  },
  {
    title: "企业名称",
    key: "oName",
    tooltip: true,
    minWidth: 140
  },
  {
    title: "联系人",
    key: "contactName",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "联系人手机号",
    key: "oPhone",
    tooltip: true,
    minWidth: 150
  },
  {
    title: "审核状态",
    slot: "state",
    tooltip: true,
    minWidth: 110
  },
  {
    title: "提交时间",
    key: "createTime",
    tooltip: true,
    minWidth: 180
  },
  {
    title: "操作",
    slot: "action",
    fixed: "right",
    minWidth: 140
  }
];
export default {
  components: {},
  mixins: [mixins, TableMixin],
  data() {
    return {
      Recovery: {
        path: [
          "/servepro/serveproercheckinfo",
          "/servepro/serveproercheckinfo"
        ],
        key: ["serve", "pageNum", "pageSize"]
      },
      tableLoading: false,
      pageTotal: 0,
      pageSize: 10,
      psize: [10, 20, 50, 100],
      pageNum: 1,
      serve: {
        proName: "",
        phone: "",
        companyName: "",
        state: "",
        createTime: []
      },
      stateList: [
        {
          id: 2,
          name: "待审核"
        },
        {
          id: 3,
          name: "已驳回"
        }
      ],
      sceneList: [], //服务场景
      dataList: [],
      dataCol: dataCol,
      search: {
        name: ""
      },
      showDialog: false,
      type: "add",
      dataForm: {},
      dataId: -1,
      showPwd: false,
      showTip: false, //操作提示
      showEdit: false, //修改应用
      flagAuth: 1, //判断用户登录状态
      senceName: "", //服务场景名称
      K: "",
      serveAddress: ""
    };
  },
  created() {
    this.serve.createTime.length > 0 &&
      (this.serve.createTime = [
        this.$moment(this.serve.createTime[0]).format("YYYY-MM-DD HH:mm"),
        this.$moment(this.serve.createTime[1]).format("YYYY-MM-DD HH:mm")
      ]);
    let status = this.$route.query.status;
    if (status) {
      this.serve.state = status * 1;
    }
    this.getList(); //获取服务提供者审核列表
  },
  mounted() {
    this.isManager = _GLOBAL.isManager();
    this.userRole = _GLOBAL.isCertified();
  },
  computed: {},
  methods: {
    // 获取我的服务列表(ok)
    getList() {
      let self = this;
      let query = {
        loginAccount: this.serve.proName,
        uPhone: this.serve.phone,
        oName: this.serve.companyName,
        auditStatus: this.serve.state,
        auditTimeBegin: this.serve.auditTimeBegin,
        auditTimeEnd: this.serve.auditTimeEnd,
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      };
      console.log("查询的信息", query);
      getServeProerChecklist(query).then(res => {
        let json = res.data.data;
        this.pageTotal = res.data.page.totalCount;
        json.forEach(item => {
          item.loginAccount = item.loginAccount || "-";
          item.email = item.email || "-";
        });
        this.dataList = json;
        console.log("服务提供者管理==服务提供者审核列表", this.dataList);
      });
    },
    // 分页==页码修改(ok)
    handlePage(value) {
      let self = this;
      self.pageNum = value;
      self.getList();
    },
    // 分页==每页显示数量修改(ok)
    sizeChange(value) {
      let self = this;
      self.pageSize = value;
      self.$nextTick(() => {
        self.getList();
      });
    },
    // 查询服务
    searchServe(time) {
      this.pageNum = 1;
      // this.pageSize = 10;
      // console.log("this.serve.createTime", this.serve.createTime);
      if (time && time.length && time[0] != "") {
        console.log("www");
        this.serve.auditTimeBegin = time[0];
        this.serve.auditTimeEnd = time[1] + " 23:59:59";
      }
      if (time && time.length && time[0] == "") {
        delete this.serve.auditTimeBegin;
        delete this.serve.auditTimeEnd;
      }
      this.getList();
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.uid,
            oid: item.id
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.serveuselist {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: auto;
  &-top {
    width: 100%;
    padding: 20px;
    .tabTopForm {
      display: flex;
      flex-wrap: wrap;
      ::v-deep .ivu-select-single .ivu-select-selection {
        height: 36px;
        padding-top: 2px;
        min-width: 150px;
      }
      // .scene {
      //   margin-right: -70px;
      // }
      // .name {
      //   margin-right: -30px;
      //   .inputName {
      //     width: 200px;
      //   }
      // }
      // .searchBtn {
      //   height: 36px;
      //   margin-left: -90px;
      // }
    }
  }
  &-content {
    margin-top: -30px;
    .state {
      max-width: 70px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .tableDom {
    width: 100%;
    .logo {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
    .dot1 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #3c8aff;
      border-radius: 50%;
    }
    .dot2 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f56c6c;
      border-radius: 50%;
    }
  }
}
</style>
